import React from 'react';
import {
  List,
  ListSubheader,
  Paper,
  Box
} from '@material-ui/core';
import TaskItem from './TaskItem';

const TaskSubsection = ({ subsection, onStatusChange, canEdit }) => {
  return (
    <Box mb={2}>
      <Paper variant="outlined">
        <List
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              {subsection.title}
            </ListSubheader>
          }
        >
          {subsection.tasks.map((task, index) => (
            <TaskItem 
              key={task.id} 
              task={task} 
              onStatusChange={(status) => onStatusChange(index, status)}
              canEdit={canEdit}
            />
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default TaskSubsection;
